var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scatter-chart',{ref:"chart",attrs:{"chart-data":_vm.datacollection,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }